import React from "react";
import { useFormikContext } from "formik";
import {
  Grid,
  TextField,
  Switch,
  FormControlLabel,
  MenuItem,
  Button,
} from "@mui/material";
import { FaFolder } from "react-icons/fa";

export default function StepDetailsForm({ roles = [], stepIndex }) {
  const { values, handleChange, touched, errors } = useFormikContext();
  const step = values?.steps?.[stepIndex];

  if (!step) return null;

  const base = `steps[${stepIndex}]`;

  const getErr = (field) => {
    const t = touched?.steps?.[stepIndex]?.[field];
    const e = errors?.steps?.[stepIndex]?.[field];
    return { show: Boolean(t && e), msg: e ? String(e) : "" };
  };

  const tf = (field) => {
    const { show, msg } = getErr(field);
    return {
      name: `${base}.${field}`,
      value: step?.[field] ?? "",
      onChange: handleChange,
      error: show,
      helperText: show ? msg : "",
    };
  };

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12, md: 12 }}>
        <TextField fullWidth label="Step Name" {...tf("stepName")} />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, md: 6 }}>
            <TextField
              select
              fullWidth
              label="Role"
              name={`${base}.roleId`}
              value={step.roleId ?? ""}
              onChange={handleChange}
              error={Boolean(touched?.steps?.[stepIndex]?.roleId && errors?.steps?.[stepIndex]?.roleId)}
              helperText={
                touched?.steps?.[stepIndex]?.roleId && errors?.steps?.[stepIndex]?.roleId
                  ? String(errors.steps[stepIndex].roleId)
                  : ""
              }
            >
              {roles.map((r) => (
                <MenuItem key={r.value} value={r.value}>
                  {r.label}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <TextField
              fullWidth
              type="number"
              label="TAT (Hours)"
              name={`${base}.tatInHours`}
              value={step.tatInHours ?? ""}
              onChange={handleChange}
            />
          </Grid>
          <Grid size={{ xs: 12, md: 12 }}>
            <TextField
              fullWidth
              multiline
              minRows={3}
              label="Description"
              name={`${base}.description`}
              value={step.description ?? ""}
              onChange={handleChange}
            />
          </Grid>
        </Grid>
      </Grid>




      <Grid size={{ xs: 12, md: 6 }}>
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, md: 12 }}>
            <FormControlLabel
              control={
                <Switch
                  checked={!!step.isActive}
                  name={`${base}.isActive`}
                  onChange={handleChange}
                />
              }
              label="Active"
            />
          </Grid>
          <Grid size={{ xs: 12, md: 12 }}>
            <FormControlLabel
              control={
                <Switch
                  checked={!!step.useForRejectionStep}
                  name={`${base}.useForRejectionStep`}
                  onChange={handleChange}
                />
              }
              label="Use as Rejection Step"
            />
          </Grid>
          <Grid size={{ xs: 12, md: 12 }}>
            <FormControlLabel
              control={
                <Switch
                  checked={!!step.saveAttachmentsInDms}
                  name={`${base}.saveAttachmentsInDms`}
                  onChange={handleChange}
                />
              }
              label="Save attachment in DMS"
            />
          </Grid>
          {step?.saveAttachmentsInDms &&
            <Grid size={{ xs: 12, md: 12 }}>
              <Button
                component="label"
                role={undefined}
                variant="contained"
                tabIndex={-1}
                startIcon={<FaFolder />}
              >
                Browse Folder
                {/* <VisuallyHiddenInput
                type="file"
                onChange={(event) => console.log(event.target.files)}
                multiple
              /> */}
              </Button>
            </Grid>
          }

        </Grid>
      </Grid>
    </Grid>
  );
}